import { useEffect, useState } from 'react'
import { CheckCircle, Dumbbell, Unlink, XCircle } from 'lucide-react'
import { api } from '../../services/api'

/** Usuario final: solo se vincula con el código. No elige de un catálogo. */
export default function TrainersPage() {
  const [trainerCode, setTrainerCode] = useState('')
  const [myTrainer, setMyTrainer] = useState<any>(null)
  const [msg, setMsg] = useState<{ ok: boolean; text: string } | null>(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    api.get('/users/me').then((r) => {
      if (r.data?.trainer) setMyTrainer(r.data.trainer)
    }).catch(() => {})
  }, [])

  const linkTrainer = async () => {
    if (!trainerCode.trim() || loading) return
    setLoading(true)
    try {
      const r = await api.post('/trainer/link-by-code', { trainerCode: trainerCode.trim().toUpperCase() })
      setMyTrainer(r.data.trainer)
      setMsg({ ok: true, text: r.data.message })
      setTrainerCode('')
    } catch (e: any) {
      setMsg({ ok: false, text: e.response?.data?.message || 'Código no válido' })
    } finally {
      setLoading(false)
    }
  }

  const unlinkTrainer = async () => {
    if (!confirm('¿Deseas desvincularte de tu entrenador?')) return
    try {
      await api.delete('/trainer/unlink')
      setMyTrainer(null)
      setMsg({ ok: true, text: 'Te has desvinculado del entrenador' })
    } catch {
      setMsg({ ok: false, text: 'Error al desvincular' })
    }
  }

  return (
    <div className="p-6 max-w-xl mx-auto">
      <h1 className="text-2xl font-bold text-gray-800 mb-2">Mi Entrenador</h1>
      <p className="text-gray-500 text-sm mb-6">Vincula a tu entrenador con el código que te dio.</p>

      <div className="card">
        {myTrainer ? (
          <div className="space-y-3">
            <div className="flex items-center gap-3 p-3 bg-green-50 rounded-xl border border-green-200">
              <div className="w-10 h-10 rounded-full bg-primary-600 flex items-center justify-center text-white font-bold text-sm flex-shrink-0">
                {myTrainer.firstName?.[0]}{myTrainer.lastName?.[0]}
              </div>
              <div>
                <p className="font-semibold text-gray-800">{myTrainer.firstName} {myTrainer.lastName}</p>
                <p className="text-sm text-gray-500">{myTrainer.email}</p>
              </div>
              <CheckCircle size={18} className="text-green-600 ml-auto flex-shrink-0" />
            </div>
            <button type="button" onClick={unlinkTrainer} className="btn-secondary flex items-center gap-2 text-sm w-full justify-center">
              <Unlink size={16} /> Desvincularme del entrenador
            </button>
          </div>
        ) : (
          <div className="space-y-3">
            <p className="text-sm text-gray-500 flex items-center gap-2">
              <Dumbbell size={16} className="text-primary-600" /> Ingresa el código de tu entrenador
            </p>
            <div className="flex gap-2">
              <input
                className="input flex-1 uppercase tracking-widest font-mono"
                placeholder="TRN-XXXXX"
                value={trainerCode}
                onChange={(e) => setTrainerCode(e.target.value.toUpperCase())}
                onKeyDown={(e) => e.key === 'Enter' && linkTrainer()}
              />
              <button type="button" onClick={linkTrainer} disabled={loading} className="btn-primary">
                {loading ? 'Verificando...' : 'Vincular'}
              </button>
            </div>
          </div>
        )}
        {msg && (
          <div className={`mt-3 flex items-center gap-2 text-sm ${msg.ok ? 'text-green-600' : 'text-red-600'}`}>
            {msg.ok ? <CheckCircle size={16} /> : <XCircle size={16} />}
            {msg.text}
          </div>
        )}
      </div>
    </div>
  )
}
